export enum GlobalCheckboxPreset {
  AcceptsMarketing = 'acceptsMarketing',
  AcceptsTerms = 'acceptsTerms',
  DefaultAddress = 'isDefaultAddress',
}
